/* eslint-disable */
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { toQueryString } from '../../api-helpers';

export interface GetProductChangelogGetPdfsQueryParams {
  changelogIds?: number[];
}

export interface GetProductChangelogGetPdfsParams {
  query: GetProductChangelogGetPdfsQueryParams;
}

export function httpGetProductChangelogGetPdfs(http: HttpClient, data: GetProductChangelogGetPdfsParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<Blob>;
export function httpGetProductChangelogGetPdfs(http: HttpClient, data: GetProductChangelogGetPdfsParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<Blob>>;
export function httpGetProductChangelogGetPdfs(http: HttpClient, data: GetProductChangelogGetPdfsParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return http.get(`{placeholder}/ProductChangelog/GetPdfs?${toQueryString(data.query)}`, { ...options, responseType: 'blob' } as any);
};

export const urlGetProductChangelogGetPdfs = (baseUrl: string, data: GetProductChangelogGetPdfsParams) => {
  return `${baseUrl}/ProductChangelog/GetPdfs?${toQueryString(data.query)}`;
};
